<div class="row no-gutters wrapper" style="height: 95%">
    <div class="col-md-12 text-center wrapper-logo d-flex justify-content-between align-items-center">
        <a href="{{env.requestsLinkUrl}}{{env.funnelHome}}" matTooltip="Homepage">
            <img src="./assets/images/home_60.png" class="header-img mr-1"/>
        </a>
        <img src="./assets/images/logo_open_fiber_magenta.png" alt=""/>
        <span class="cursor-pointer" (click)="helpersService.logout()" matTooltip="Logout">
            <img src="./assets/images/logout_60.png" class="header-img mr-1"/>
        </span>
    </div>
    <div class="no-gutters row w-100">

        <div class="col-sm-7 col-md-8 rounded-left shadow">
            <app-map #map (mapLoaded)="onMapLoaded()" (leftClick)="placePointPreview($event.latLng)"
                     (clickPop)="onClickPop($event)" (clickPfs)="onClickPfs($event)" (clickRoe)="onClickRoe($event)"
                     (clickCno)="onClickRpi($event, 'CNO')" (clickPozzetti)="onClickRpi($event, 'POZZETTO')"
                     (clickPoi)="onClickPoi($event)" (clickSchool)="onSelectSchool($event, null, true)"
                     (clickHealthcare)="onSelectHealtcare($event, null, true)"
                     (clickBuilding)="onSelectBuilding($event, null)" (clickBts)="onSelectBts($event, null)"
                     [poiList]="poiList" [healthcareList]="healthcareList" [pfsList]="pfsList" [roeList]="roeList"
                     [cnoList]="cnoList" [pozzettoList]="pozzettoList" [noaList]="btsList.NOA"
                     [nationalPops]="nationalPops"
                     [provincialPops]="provincialPops" [cdPops]="cdPops" [agfPops]="agfPops" [schoolList]="schoolList"
                     [kmlList]="kmlList" [btsClusters]="btsClusters" [buildingClusters]="buildingClusters"
                     [schoolClusters]="schoolClusters" [healthcareClusters]="healthcareClusters"
                     [puntiIntermediClusters]="puntiIntermediClusters" [healthcareForMap]="healthcareForMap"
                     [schoolForMap]="schoolForMap" (mapZoom)="onMapZoom($event)" (dragEnd)="onDragEnd($event)"
                     [canAddPoints]="canAddPoints">
            </app-map>

            <div class="map-button">
                <app-map-button
                        *ngIf="config.pop.load || config.pcn.load || (env.controls.agf && config.pop_agf.load) || env.controls.agf_pop"
                        [btnOptions]="landingPageService.mapButtons.pops"
                        [styleButton]="landingPageService.mapButtons.pops.active ? 'active' : ''"
                        (click)="toggleMapButton('pops')">
                </app-map-button>
                <app-map-button *ngIf="config.poi.load" [btnOptions]="landingPageService.mapButtons.poi"
                                [styleButton]="landingPageService.mapButtons.poi.active ? 'active' : ''"
                                (click)="toggleMapButton('poi')">
                </app-map-button>
                <app-map-button *ngIf="config.kml" [btnOptions]="landingPageService.mapButtons.kml"
                                [styleButton]="landingPageService.mapButtons.kml.active ? 'active' : ''"
                                (click)="toggleMapButton('kml')">
                </app-map-button>
                <app-map-button [btnOptions]="landingPageService.mapButtons.legenda" [styleButton]="'modal-button'"
                                (click)="openLegenda()">
                </app-map-button>
            </div>
        </div>

        <div class="col-sm-5 col-md-4 px-5 py-5 bg-white rounded-right shadow d-flex align-items-between">

            <app-services-description class="w-100" [user]="user" [config]="config" [descriptionMinHeight]="this.selectedPoints?.length > 2 ? '0px' : '80px'">


                <div *ngIf="isTrasloco">
                    <div *ngFor="let key of resKeys; let i = index;">
                        <ng-container *ngIf="(responseTmp[key] && responseTmp[key].label) || this.mode == 'add'">

<!--                            <ng-container *ngIf="!responseTmp[key]?.is_editable && this.mode == 'edit'">-->
<!--                                <div class="form-row m-0">-->
<!--                                    <mat-form-field appearance="outline" class="input-bea w-100">-->
<!--                                        <input matInput-->
<!--                                               [value]="responseTmp[key]?.label ? responseTmp[key]?.label : responseTmp[key]?.id_building"-->
<!--                                               type="text" [disabled]="true"/>-->
<!--                                    </mat-form-field>-->
<!--                                </div>-->
<!--                            </ng-container>-->

                            <div class="row no-gutters">
                                <label class="editable-text col-12" *ngIf="responseTmp[key]?.is_editable || this.mode === 'add'">
                                    {{
                                        mode === 'edit'
                                            ? 'Il punto da modificare è: ' + (
                                            responseTmp[key]
                                                ? (responseTmp[key]?.label || responseTmp[key]?.id_building || 'N/A')
                                                : 'Nessun dato disponibile'
                                        )
                                            : 'Seleziona il punto da aggiungere:'
                                    }}
                                </label>

                                <div class="switch-select m-0 col-3"
                                     *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods">
                                    <mat-form-field appearance="outline" class="w-100 switch">
                                        <mat-select [(ngModel)]="requestsType[i]" [disabled]="responseTmp[key]?.is_editable === false"
                                                    (selectionChange)="resetPoint($event.value, i)">
                                            <mat-option [value]="mode.value" *ngFor="let mode of switchValues[i]">
                                                {{ mode.viewValue }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-9">

                                    <app-address-search
                                            class="switch-address-search {{ requestsType[i] === 'address' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.address ? 'd-block' : 'd-none' }}"
                                            (placeSelected)="confirmAddress($event, i)"
                                            (placeChanged)="onPlaceChanged(i)"
                                            [disabled]="responseTmp[key]?.is_editable === false"
                                            [requestType]="requestsType[i]" [label]="labels[i]">
                                    </app-address-search>
                                    <app-coordinates-search #coordinatesSearch
                                                            class="switch-address-search {{ (requestsType[i] === 'coordinates_ed50' || requestsType[i] === 'coordinates') && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.coordinates ? 'd-block' : 'd-none' }}"
                                                            (placeSelected)="confirmCoordinates($event, i)"
                                                            (placeChanged)="onPlaceChanged(i)"
                                                            [disabled]="responseTmp[key]?.is_editable === false"
                                                            (placeRemoved)="confirmCoordinates(null, i)"
                                                            [requestType]="requestsType[i]" [addressLabel]="labels[i]"
                                                            [coordinatesType]="requestsType[i]">
                                    </app-coordinates-search>
                                    <app-id-search class="switch-address-search
                                            {{ (requestsType[i] === 'id_bts_noa' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_bts_noa) ||
                                            (requestsType[i] === 'id_bts_building' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_bts_building) ||
                                            (requestsType[i] === 'id_building' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_building) ||
                                            (requestsType[i] === 'id_school' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_school) ||
                                            (requestsType[i] === 'id_healthcare' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_healthcare)
                                            ? 'd-block' : 'd-none' }}" (placeSelected)="confirmId($event, i)"
                                                   (placeChanged)="onPlaceChanged(i)"
                                                   (placeRemoved)="confirmId(null, i)"
                                                   [config]="config" [requestType]="requestsType[i]"
                                                   [addressLabel]="labels[i]"
                                                   [disabled]="responseTmp[key]?.is_editable === false">
                                    </app-id-search>
                                    <app-comune-noa-autocomplete
                                            *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_noa"
                                            class="switch-address-search {{ requestsType[i] === 'city_noa' ? 'd-block' : 'd-none' }}"
                                            [comuniList]="citiesNoa" [comuneLabel]="cities[i]"
                                            (comuneSelected)="onComuneSelected($event, i, 'NOA')">
                                    </app-comune-noa-autocomplete>
                                    <app-comune-building-autocomplete
                                            *ngIf="env.controls.agf && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_building"
                                            class="switch-address-search {{ requestsType[i] === 'city_building' ? 'd-block' : 'd-none' }}"
                                            [comuniList]="citiesBuilding" [comuneLabel]="cities[i]"
                                            (comuneSelected)="onComuneSelected($event, i, 'BUILDING')">
                                    </app-comune-building-autocomplete>
                                    <app-pop-autocomplete
                                            *ngIf="popListAutocomplete && popListAutocomplete.length && requestsType[i] === 'pop' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop"
                                            class="switch-address-search {{ requestsType[i] === 'pop' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop ? 'd-block' : 'd-none' }}"
                                            [(label)]="labels[i]" [popList]="popListAutocomplete"
                                            [placeholder]="requestsType[i] === 'pop_agf' ? 'Select BI1G' : 'Select Pop'"
                                            (placeSelected)="confirmPop($event, i)" (placeChanged)="onPlaceChanged(i)">
                                    </app-pop-autocomplete>
                                    <app-basic-autocomplete *ngIf="pfsList?.length"
                                                            class="switch-address-search {{ requestsType[i] === 'pfs' && pfsList && pfsList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pfs ? 'd-block' : 'd-none' }}"
                                                            [elementLabel]="labels[i]" [elementList]="pfsList"
                                                            [elementProperty]="'code'"
                                                            [elementPlaceholder]="'Select'"
                                                            (placeSelected)="confirmPfs($event, i)">
                                    </app-basic-autocomplete>

                                    <app-basic-autocomplete
                                            class="switch-address-search {{ requestsType[i] === 'roe' && roeList && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.roe ? 'd-block' : 'd-none' }}"
                                            [elementLabel]="labels[i]" [elementList]="roeList"
                                            [elementProperty]="'code'"
                                            [elementPlaceholder]="'Select'" (placeSelected)="confirmRoe($event, i)">
                                    </app-basic-autocomplete>
                                    <app-poi-autocomplete *ngIf="popListAutocomplete && popListAutocomplete.length"
                                                          class="switch-address-search {{ requestsType[i] === 'poi' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && poiList && poiList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.poi &&
                                            ((pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop)
                                            || !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop) ? 'd-block' : 'd-none' }}"
                                                          [(label)]="labels[i]" [poiList]="poiList"
                                                          [popList]="popListAutocomplete"
                                                          [autocompletePop]="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.popAndPoiAutocomplete"
                                                          (placeSelected)="confirmPopOrPoi($event, i)"
                                                          (placeChanged)="onPlaceChanged(i)">
                                    </app-poi-autocomplete>
                                    <app-basic-autocomplete
                                            *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi && config.punti_intermedi && config.punti_intermedi.types"
                                            class="{{ requestsType[i] === 'punti_intermedi' ? 'd-block' : 'd-none' }}"
                                            [elementLabel]="labels[i]" [elementList]="puntiIntermediTypesTranslated"
                                            [elementProperty]="null" [elementPlaceholder]="'Select'"
                                            (placeSelected)="onSelectRpiType($event)">
                                    </app-basic-autocomplete>

                                </div>
                            </div>
                        </ng-container>


                        <!-- for PUNTI INTERMEDI only -->
                        <div class="row no-gutters">
                            <!-- left -->
                            <div class="switch-select m-0 col-3 {{ requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                                 *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi && isEditable">
                                <mat-form-field appearance="outline" class="w-100 switch">
                                    <mat-select [(ngModel)]="requestsTypeRpi[i]"
                                                (selectionChange)="onChangeRpiMethod($event.value, i)">
                                        <mat-option [value]="mode.value" *ngFor="let mode of switchValuesRpi">
                                            {{ mode.viewValue }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- right -->
                            <div class="col-9">
                                <app-comune-rpi-autocomplete
                                        *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi"
                                        class="switch-address-search {{ requestsTypeRpi[i] === 'city_rpi' && requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                                        [comuniList]="citiesRpi[searchedType.key]" [comuneLabel]="cities[i]"
                                        (comuneSelected)="onSelectRpiComune($event)">
                                </app-comune-rpi-autocomplete>

                                <app-id-search *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi"
                                               class="switch-address-search {{ requestsTypeRpi[i] === 'id_rpi' && requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                                               (placeSelected)="confirmId($event, i)" (placeChanged)="onPlaceChanged(i)"
                                               (placeRemoved)="confirmId(null, i)" [config]="config"
                                               [requestType]="requestsType[i]" [addressLabel]="labelsRpi[i]">
                                </app-id-search>
                            </div>


                            <!-- standalone -->
                            <div class="col-12">
                                <app-poi-autocomplete *ngIf="popListAutocomplete && popListAutocomplete.length"
                                                      class="{{ requestsType[i] === 'poi' && !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && poiList && poiList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.poi &&
                            ((pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop)
                            || !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop) ? 'd-block' : 'd-none' }}"
                                                      [labels]="labels[i]" [poiList]="poiList"
                                                      [popList]="popListAutocomplete"
                                                      [autocompletePop]="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.popAndPoiAutocomplete"
                                                      (placeSelected)="confirmPopOrPoi($event, i)"
                                                      (placeChanged)="onPlaceChanged(i)">
                                </app-poi-autocomplete>
                            </div>

                            <div class="col-12">
                                <app-basic-autocomplete
                                        class="{{ requestsType[i] === 'punti_intermedi' && requestsTypeRpi[i] === 'city_rpi' && searchedType.key && rpiList[searchedType.key] && rpiList[searchedType.key].length ? 'd-block' : 'd-none' }}"
                                        [elementLabel]="labelsRpi[i]" [elementList]="rpiList[searchedType.key]"
                                        [elementProperty]="'code'" [elementPlaceholder]="'Select'"
                                        (placeSelected)="onSelectRpi($event.point)">
                                </app-basic-autocomplete>
                            </div>

                            <div class="col-12" [class.d-none]="!additionalAutocompletes[i]">
                                <app-basic-autocomplete
                                        class="{{ requestsType[i] === 'city_noa' ? 'd-block' : 'd-none' }}"
                                        [elementLabel]="labels[i]" [elementList]="btsLists[i]?.NOA"
                                        [elementProperty]="'code'" [elementPlaceholder]="'Select Node'"
                                        (placeSelected)="onSelectBts($event.point, i, false)">
                                </app-basic-autocomplete>

                                <app-basic-autocomplete *ngIf="env.controls.agf"
                                                        class="{{ requestsType[i] === 'city_building' ? 'd-block' : 'd-none' }}"
                                                        [elementLabel]="labels[i]" [elementList]="btsLists[i]?.BUILDING"
                                                        [elementProperty]="'points,code'"
                                                        [elementPlaceholder]="'Select BI1G'"
                                                        (placeSelected)="onSelectBts($event.point, i, false)">
                                </app-basic-autocomplete>
                            </div>
                        </div>

                        <div [class.d-none]="!showDivider || !config.multiple_points.initial_points || config.multiple_points.initial_points.length <= 1 || i > 0"
                             class="col-12">
                            <hr>
                        </div>

                        <span
                                class="w-100 mb-3 text-secondary {{ requestsType[0] === 'import' && config.data.api.massiveImport.info_message ? 'd-block' : 'd-none' }}">
                            {{ config.data.api.massiveImport.info_message }}
                        </span>
                        <div (click)="downloadTemplate()"
                             class="text-center cursor-pointer blue w-100 {{ requestsType[0] === 'import' ? 'd-block' : 'd-none' }}">
                            <i class="fas fa-download excel-download mr-2"></i>
                            Download template
                        </div>


                    </div>
                </div>


                <div *ngIf="!isTrasloco" class="scrollable-container">
                    <div *ngFor="let p of selectedPoints; let i = index;let first=first" class="row no-gutters">
<!--                        <hr *ngIf="!first && this.env.serviceSlug != 'bea'" style="width: 100%;" />-->

                        <!-- left -->
                        <div class="switch-select m-0 col-3"
                             *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods">
                            <mat-form-field appearance="outline" class="w-100 switch">
                                <mat-select [(ngModel)]="requestsType[i]"
                                            (selectionChange)="resetPoint($event.value, i);">
                                    <mat-option [value]="mode.value" *ngFor="let mode of switchValues[i]">
                                        {{ mode.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <!-- right -->
                        <div class="col-9">

                            <app-address-search
                                    class="switch-address-search {{ requestsType[i] === 'address' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.address ? 'd-block' : 'd-none' }}"
                                    (placeSelected)="confirmAddress($event, i)" (placeChanged)="onPlaceChanged(i)"
                                    [requestType]="requestsType[i]" [label]="labels[i]">
                            </app-address-search>


                            <app-coordinates-search #coordinatesSearch
                                                    class="switch-address-search {{ (requestsType[i] === 'coordinates_ed50' || requestsType[i] === 'coordinates') && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.coordinates ? 'd-block' : 'd-none' }}"
                                                    (placeSelected)="confirmCoordinates($event, i)"
                                                    (placeChanged)="onPlaceChanged(i)"
                                                    (placeRemoved)="confirmCoordinates(null, i)"
                                                    [requestType]="requestsType[i]"
                                                    [addressLabel]="labels[i]" [coordinatesType]="requestsType[i]">
                            </app-coordinates-search>

                            <app-id-search class="switch-address-search
                            {{ (requestsType[i] === 'id_bts_noa' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_bts_noa) ||
                            (requestsType[i] === 'id_bts_building' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_bts_building) ||
                            (requestsType[i] === 'id_building' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_building) ||
                            (requestsType[i] === 'id_school' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_school) ||
                            (requestsType[i] === 'id_healthcare' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.id_healthcare)
                            ? 'd-block' : 'd-none' }}" (placeSelected)="confirmId($event, i)"
                                           (placeChanged)="onPlaceChanged(i)" (placeRemoved)="confirmId(null, i)"
                                           [config]="config"
                                           [requestType]="requestsType[i]" [addressLabel]="labels[i]">
                            </app-id-search>

                            <app-comune-noa-autocomplete *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_noa"
                                                         class="switch-address-search {{ requestsType[i] === 'city_noa' ? 'd-block' : 'd-none' }}"
                                                         [comuniList]="citiesNoa" [comuneLabel]="cities[i]"
                                                         (comuneSelected)="onComuneSelected($event, i, 'NOA')">
                            </app-comune-noa-autocomplete>


                            <app-comune-pop-autocomplete
                                    *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_pop && requestsType[i] === 'city_pop'"
                                    class="switch-address-search d-block" [comuniList]="citiesPop"
                                    [(comuneLabel)]="cityLabelPop[i]"
                                    (comuneSelected)="onSelectPopComune($event, i, 'POP')">
                            </app-comune-pop-autocomplete>
                            <app-comune-poi-autocomplete
                                    *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_poi && requestsType[i] === 'city_poi'"
                                    class="switch-address-search d-block" [comuniList]="citiesPoi"
                                    [(comuneLabel)]="cityLabelPoi[i]"
                                    (comuneSelected)="onSelectPoiComune($event, i, 'POI')">
                            </app-comune-poi-autocomplete>

                            <app-comune-building-autocomplete
                                    *ngIf="env.controls.agf && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_building"
                                    class="switch-address-search {{ requestsType[i] === 'city_building' ? 'd-block' : 'd-none' }}"
                                    [comuniList]="citiesBuilding" [comuneLabel]="cities[i]"
                                    (comuneSelected)="onComuneSelected($event, i, 'BUILDING')">
                            </app-comune-building-autocomplete>

                            <app-pop-autocomplete *ngIf="popListAutocomplete && popListAutocomplete.length"
                                                  class="switch-address-search {{ requestsType[i] === 'pop' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop ? 'd-block' : 'd-none' }}"
                                                  [(label)]="popLabels[i]" [popList]="popListAutocomplete" [index]="i"
                                                  [placeholder]="requestsType[i] === 'pop_agf' ? 'Select BI1G' : 'Select Pop'"
                                                  (placeSelected)="confirmPop($event, i)"
                                                  (placeChanged)="onPlaceChanged(i)">
                            </app-pop-autocomplete>

                            <app-basic-autocomplete *ngIf="pfsList?.length"
                                                    class="switch-address-search {{ requestsType[i] === 'pfs' && pfsList && pfsList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pfs ? 'd-block' : 'd-none' }}"
                                                    [elementLabel]="labels[i]" [elementList]="pfsList"
                                                    [elementProperty]="'code'"
                                                    [elementPlaceholder]="'Select'"
                                                    (placeSelected)="confirmPfs($event, i)">
                            </app-basic-autocomplete>

                            <app-basic-autocomplete
                                    class="switch-address-search {{ requestsType[i] === 'roe' && roeList && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.roe ? 'd-block' : 'd-none' }}"
                                    [elementLabel]="labels[i]" [elementList]="roeList" [elementProperty]="'code'"
                                    [elementPlaceholder]="'Select'" (placeSelected)="confirmRoe($event, i)">
                            </app-basic-autocomplete>

                            <app-poi-autocomplete *ngIf="popListAutocomplete && popListAutocomplete.length"
                                                  class="switch-address-search {{ requestsType[i] === 'poi' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && poiList && poiList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.poi &&
                            ((pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop)
                            || !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop) ? 'd-block' : 'd-none' }}"
                                                  [(label)]="poiLabels[i]" [poiList]="poiList"
                                                  [popList]="popListAutocomplete" [index]="i"
                                                  [autocompletePop]="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.popAndPoiAutocomplete"
                                                  (placeSelected)="confirmPopOrPoi($event, i)"
                                                  (placeChanged)="onPlaceChanged(i)">
                            </app-poi-autocomplete>


                            <app-basic-autocomplete
                                    *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi && config.punti_intermedi && config.punti_intermedi.types"
                                    class="{{ requestsType[i] === 'punti_intermedi' ? 'd-block' : 'd-none' }}"
                                    [elementLabel]="labels[i]" [elementList]="puntiIntermediTypesTranslated"
                                    [elementProperty]="null" [elementPlaceholder]="'Select'"
                                    (placeSelected)="onSelectRpiType($event)">
                            </app-basic-autocomplete>

                            <app-basic-autocomplete
                                    *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop_pcn_xpop && config.pop_pcn_xpop && config.pop_pcn_xpop.types"
                                    class="{{ requestsType[i] === 'pop_pcn_xpop' ? 'd-block' : 'd-none' }}"
                                    [elementLabel]="labels[i]" [elementList]="wavelengthTypesTranslated"
                                    [elementProperty]="null" [elementPlaceholder]="'Select'"
                                    (placeSelected)="onSelectWavelengthType($event, i)">
                            </app-basic-autocomplete>

                            <app-upload-input
                                    class="switch-upload-file {{ requestsType[i] === 'import' && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.upload ? 'd-block' : 'd-none' }}"
                                    [fileName]="savedFile?.attachment_name" (emitClick)="onClickUploadInput()"
                                    (cancelFile)="onCancelFile()">
                            </app-upload-input>

                        </div>

                        <div class="col-12" *ngIf="annoBandoRequired && isAnnoBandoDropdownVisible && i==0">
                            <div class="switch-select">
                                <mat-form-field appearance="standard" class="w-100 switch">
                                    <mat-label>Seleziona Anno Bando</mat-label>
                                    <mat-select [(ngModel)]="annoBando">
                                        <mat-option *ngFor="let annoBandoOption of annoBandoOptions" [value]="annoBandoOption">
                                            {{ annoBandoOption }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>


                        <!-- for PUNTI INTERMEDI only -->
                        <!-- left -->
                        <div class="switch-select m-0 col-3 {{ requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                             *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi && isEditable">
                            <mat-form-field appearance="outline" class="w-100 switch">
                                <mat-select [(ngModel)]="requestsTypeRpi[i]"
                                            (selectionChange)="onChangeRpiMethod($event.value, i)">
                                    <mat-option [value]="mode.value" *ngFor="let mode of switchValuesRpi">
                                        {{ mode.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- right -->
                        <div class="col-9">
                            <app-comune-rpi-autocomplete
                                    *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi"
                                    class="switch-address-search {{ requestsTypeRpi[i] === 'city_rpi' && requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                                    [comuniList]="citiesRpi[searchedType.key]" [comuneLabel]="cities[i]"
                                    (comuneSelected)="onSelectRpiComune($event)">
                            </app-comune-rpi-autocomplete>

                            <app-id-search *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.punti_intermedi"
                                           class="switch-address-search {{ requestsTypeRpi[i] === 'id_rpi' && requestsType[i] === 'punti_intermedi' && searchedType.key ? 'd-block' : 'd-none' }}"
                                           (placeSelected)="confirmId($event, i)" (placeChanged)="onPlaceChanged(i)"
                                           (placeRemoved)="confirmId(null, i)" [config]="config"
                                           [requestType]="requestsType[i]"
                                           [addressLabel]="labelsRpi[i]">
                            </app-id-search>
                        </div>

                        <!-- for WAVELENGTH only (POP/PCN/XPOP) -->
                        <!-- left -->


                        <!-- <div class="switch-select m-0 col-3 {{ requestsType[i] === 'pop_pcn_xpop' && searchedType.key ? 'd-block' : 'd-none' }}" *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop_pcn_xpop && isEditable">
						<mat-form-field appearance="outline" class="w-100 switch">
							<mat-select [(ngModel)]="requestsTypeWavelength[i]"
							(selectionChange)="onChangeWavelengthMethod($event.value, i)">
							<mat-option [value]="mode.value" *ngFor="let mode of switchValuesWavelength">
								{{ mode.viewValue }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div> -->

                        <!-- right -->
                        <!-- <div class="col-9"> -->
                        <!--
                        <app-comune-noa-autocomplete *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_noa"
                            class="switch-address-search {{ requestsType[i] === 'city_noa' ? 'd-block' : 'd-none' }}"
                            [comuniList]="citiesNoa" [comuneLabel]="cities[i]"
                            (comuneSelected)="onComuneSelected($event, i, 'NOA')">
                        </app-comune-noa-autocomplete>

                        <app-comune-wavelength-autocomplete *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.city_noa"
                            class="switch-address-search {{ requestsTypeWavelength[i] === 'city_wavelength' && requestsType[i] === 'pop_pcn_xpop' && searchedType.key ? 'd-block' : 'd-none' }}"
                            [comuniList]="citiesWavelength[searchedType.key]" [comuneLabel]="cities[i]"
                            (comuneSelected)="onSelectWavelengthComune($event)">
                        </app-comune-wavelength-autocomplete> -->

                        <!-- <app-id-search *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop_pcn_xpop"
                            class="switch-address-search {{ requestsTypeWavelength[i] === 'id_wavelength' && requestsType[i] === 'pop_pcn_xpop' && searchedType.key ? 'd-block' : 'd-none' }}"
                            (placeSelected)="confirmId($event, i)" (placeChanged)="onPlaceChanged(i)"
                            (placeRemoved)="confirmId(null, i)" [config]="config" [requestType]="requestsType[i]"
                            [addressLabel]="labelsWavelength[i]">
                        </app-id-search> -->
                        <!-- </div> -->

                        <!-- standalone -->
                        <div class="col-12">
                            <app-poi-autocomplete *ngIf="popListAutocomplete && popListAutocomplete.length" class="{{ requestsType[i] === 'poi' && !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods && poiList && poiList.length && pointsConfig[i > 0 ? 'a_end' : 'b_end']?.poi &&
                            ((pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop)
                            || !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.pop) ? 'd-block' : 'd-none' }}"
                                                  [(label)]="poiLabels[i]" [poiList]="poiList"
                                                  [popList]="popListAutocomplete" [index]="i"
                                                  [autocompletePop]="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.popAndPoiAutocomplete"
                                                  (placeSelected)="confirmPopOrPoi($event, i)"
                                                  (placeChanged)="onPlaceChanged(i)">
                            </app-poi-autocomplete>
                        </div>

                        <div class="col-12">
                            <app-basic-autocomplete
                                    class="{{ requestsType[i] === 'punti_intermedi' && requestsTypeRpi[i] === 'city_rpi' && searchedType.key && rpiList[searchedType.key] && rpiList[searchedType.key].length ? 'd-block' : 'd-none' }}"
                                    [elementLabel]="labelsRpi[i]" [elementList]="rpiList[searchedType.key]"
                                    [elementProperty]="'code'" [elementPlaceholder]="'Select'"
                                    (placeSelected)="onSelectRpi($event.point)">
                            </app-basic-autocomplete>
                        </div>

                        <div class="col-12" [class.d-none]="!additionalAutocompletes[i]">
                            <app-basic-autocomplete class="{{ requestsType[i] === 'city_pop' ? 'd-block' : 'd-none' }}"
                                                    [(elementLabel)]="popByCityLabels[i]"
                                                    [elementList]="wavelengthLists[i]?.POP"
                                                    [index]="i" [elementProperty]="'nome'"
                                                    [elementPlaceholder]="'Select POP'"
                                                    (placeSelected)="confirmPopOrPoi($event, i)">
                            </app-basic-autocomplete>
                            <!-- elementProperty è l'elemento nella response che è comune a tutti i punti e va fatto visualizzare -->


                            <app-basic-autocomplete class="{{ requestsType[i] === 'city_poi' ? 'd-block' : 'd-none' }}"
                                                    [(elementLabel)]="poiByCityLabels[i]"
                                                    [elementList]="wavelengthLists[i]?.POI"
                                                    [index]="i" [elementProperty]="'fullname'"
                                                    [elementPlaceholder]="'Select POI'"
                                                    (placeSelected)="confirmPopOrPoi($event, i)">
                            </app-basic-autocomplete>
                        </div>

                        <div class="col-12" [class.d-none]="!additionalAutocompletes[i]">
                            <app-basic-autocomplete class="{{ requestsType[i] === 'city_noa' ? 'd-block' : 'd-none' }}"
                                                    [elementLabel]="labels[i]" [elementList]="btsLists[i]?.NOA"
                                                    [elementProperty]="'code'"
                                                    [elementPlaceholder]="'Select Node'"
                                                    (placeSelected)="onSelectBts($event.point, i, false)">
                            </app-basic-autocomplete>

                            <app-basic-autocomplete *ngIf="env.controls.agf"
                                                    class="{{ requestsType[i] === 'city_building' ? 'd-block' : 'd-none' }}"
                                                    [elementLabel]="labels[i]" [elementList]="btsLists[i]?.BUILDING"
                                                    [elementProperty]="'points,code'"
                                                    [elementPlaceholder]="'Select BI1G'"
                                                    (placeSelected)="onSelectBts($event.point, i, false)">
                            </app-basic-autocomplete>
                        </div>

                        <div [class.d-none]="!showDivider || !config.multiple_points.initial_points || config.multiple_points.initial_points.length <= 1 || i > 0"
                             class="col-12">
                            <hr>
                        </div>

                        <span
                                class="w-100 mb-3 text-secondary {{ requestsType[0] === 'import' && config.data.api.massiveImport.info_message ? 'd-block' : 'd-none' }}">
                            {{ config.data.api.massiveImport.info_message }}
                        </span>
                        <div (click)="downloadTemplate()"
                             class="text-center cursor-pointer blue w-100 {{ requestsType[0] === 'import' ? 'd-block' : 'd-none' }}">
                            <i class="fas fa-download excel-download mr-2"></i>
                            Download template
                        </div>

                    </div>
                </div>


                <ng-container *ngIf="canAddPoints && !isTrasloco">
                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <span>
                            <button
                                    [class.d-flex]="selectedPoints && selectedPoints.length && selectedPoints.length > 1"
                                    mat-flat-button (click)="removeSearchInput(inputsNumber - 1)"
                                    class="d-none text-red">
                                <i class="fas fa-minus mr-2"></i>
                                Remove Point
                            </button>
                        </span>
                        <span>
                            <button
                                    [class.d-flex]="selectedPoints && selectedPoints.length &&
                                selectedPoints.length <= (config.multiple_points.max - 1) && requestsType[0] !== 'import'"
                                    mat-flat-button (click)="addSearchInput(config.multiple_points.initial_points[0])"
                                    class="d-none drop-area-content">
                                <i class="fas fa-plus mr-2"></i>
                                Add Point
                            </button>
                        </span>
                    </div>
                </ng-container>

                <div class="my-3 d-flex flex-column justify-content-center align-items-center">
                    <app-button *ngIf="requestsType[0] !== 'import'" [isRounded]="false" [isEnabled]="isButtonEnabled"
                                [isWaitingBuildings]="isWaitingBuildings" [feasibilityBlocked]="feasibilityBlocked"
                                [selectedPoints]="selectedPoints" (clickButton)="checkFeasibility()">
                        <ng-container
                                *ngIf="!pointsConfig['b_end']?.switch_methods && ((selectedPoints[0] && selectedPoints[0].type?.toLowerCase() == 'pop') || !selectedPoints[0] || !selectedPoints[0].type)">
                            <i class="fas fa-search mr-3"></i>
                            Search
                        </ng-container>
                        <ng-container
                                *ngIf="selectedPoints && selectedPoints[0]?.type?.toLowerCase() == 'poi' && !pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods">
                            <i class="fas fa-arrow-right mr-3"></i>
                            Proceed
                        </ng-container>
                        <ng-container *ngIf="pointsConfig[i > 0 ? 'a_end' : 'b_end']?.switch_methods ">
                            <i class="fas fa-arrow-right mr-3"></i>
                            Check feasibility
                        </ng-container>
                    </app-button>
                    <app-button *ngIf="requestsType[0] === 'import' && savedFile" [isRounded]="true" [isEnabled]="true"
                                (clickButton)="uploadFile()" [selectedFile]="savedFile" [isUpload]="true">
                        <ng-container>
                            Upload
                        </ng-container>
                    </app-button>
                    <span *ngIf="feasibilityBlocked" class="text-error font-08">At least 2 points are necessary.</span>
                </div>
            </app-services-description>
        </div>
    </div>
    <app-massive-import-view *ngIf="env.controls.massive_import_two_steps && showMassiveDetail"
                             [documentId]="documentId"></app-massive-import-view>
</div>

<div *ngIf="showToast" aria-live="polite" aria-atomic="true" class="parent-toast" style="min-height: 120px;">
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="w-100">
            <div class="toast-body">
                <p *ngIf="tempPoint && tempPoint.label" class="mt-2 mb-1">{{ tempPoint.label }}</p>
                <div class="toast-points-row no-wrap-scroll">
                <div *ngFor="let point of selectedPoints; let i = index">
                    <ng-container *ngIf="config.multiple_points.max > 1">
                        <p *ngIf="(tempPoint && 
                        (config.multiple_points.variable ||
                        (pointsConfig[i > 0 ? 'a_end' : 'b_end'][tempPoint.type.toLowerCase()] || pointsConfig[i > 0 ? 'a_end' : 'b_end']['id_'+tempPoint.type.toLowerCase()])
                        )
                        )" class="btn btn-sm save-whats-here mb-0"
                           (click)="onSelectPlaceFromToast(tempPoint, i, tempPoint.type)">

                            <span class="d-flex flex-column ligther justify-content-center align-items-center">
                                <!--  gestione nel caso di bea multipunto dei marker nella toast-->
                                <img [src]="'./assets/images/ico_p' + i + '.png'" class="toast-image"/>
                                <span class="mt-1">
                                  {{ env?.serviceSlug === 'bea' ? 'P' + (i + 1) : inputNames[i] }}
                                </span>
                            </span>
                        </p>
                    </ng-container>
                    <ng-container *ngIf="config.multiple_points.max <= 1">
                        <span class="btn btn-sm save-whats-here mb-0 mr-3">
                            <span class="d-flex flex-column ligther justify-content-center align-items-center">
                                <img src='{{ "./assets/images/picked_marker.png" }}' class="toast-image"/>
                            </span>
                        </span>
                        <span *ngIf="selectedPoints[0] && selectedPoints[0].label"
                              class="mt-2 mb-1">{{ selectedPoints[0].label }}</span>
                    </ng-container>
                </div>
                </div>
            </div>
            <button type="button" class="ml-2 mb-1 close close-btn" data-dismiss="toast" aria-label="Close"
                    (click)="closeToast(true)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>

<app-modal-multi-building #modalMultiBuilding [end]="modalEnd" (selectBuilding)="onClickBuilding($event)"
                          (dismissModal)="onDismissModalMultiBuilding($event)">
</app-modal-multi-building>

<app-modal-multi-points #modalMultiPoints [end]="modalEnd" (selectElement)="onSelectBts($event, modalEnd)"
                        (dismissModal)="onDismissModalMultiBuilding($event)">
</app-modal-multi-points>

<app-modal-sanita-scuole #modalComponentSS [end]="modalEnd" (selectBuilding)="onClickModaleSS($event)"
                         (dismissModal)="onDismissModalMultiBuilding($event)">
</app-modal-sanita-scuole>
